var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudience = function SvgAudience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.42 6.5c.989.457 1.668 1.405 1.668 2.5s-.68 2.043-1.667 2.5M6.44 6.5c-.987.457-1.666 1.405-1.666 2.5s.679 2.043 1.666 2.5M12.43 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM7.43 18c1.298-1.858 3.06-3 5-3 1.941 0 3.703 1.142 5 3M2.43 18c.72-.969 1.813-2 3.313-2.5M22.43 18c-.718-.969-1.812-2-3.312-2.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAudience;